module.exports = __webpack_public_path__ + "static/media/Cats eyes 05_ENGELSKA-mixdown.13079c76.mp3";